import theme from "@/styles/theme";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { de } from "date-fns/locale";

export default function EventDateTime({ event }) {
  return (
    <Box sx={eventDateTimeStyles(event)}>
      <Grid container columnSpacing={2}>
        <Grid item xs={12} lg="auto">
          <Grid container alignItems="center">
            <Grid item xs="auto">
              <CalendarTodayIcon className="event-date-time-location-icon" />
            </Grid>
            <Grid item xs="auto">
              <Typography className="event-date-time-location">
                {format(new Date(event.date_start), "dd.MM.yy", { locale: de })}
                {event.time_start &&
                  `, ${format(new Date(event.time_start), "HH:mm", { locale: de })} Uhr`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {event.location?.name && (
          <Grid item xs={12} lg>
            <Grid container alignItems="center">
              <Grid item xs="auto">
                <LocationOnIcon className="event-date-time-location-icon" />
              </Grid>
              <Grid item xs>
                <Tooltip
                  className="event-date-time-location-tooltip"
                  title={event.location?.name || event.zipcode?.label}
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, -10],
                          },
                        },
                      ],
                    },
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: theme.palette.secondary.main,
                        "& .MuiTooltip-arrow": {
                          color: theme.palette.secondary.main,
                        },
                      },
                    },
                  }}
                  arrow
                  placement="bottom-start"
                >
                  <Typography className="event-date-time-location">
                    {event.zipcode?.label}, {event.location?.name}
                  </Typography>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

const eventDateTimeStyles = (event) => ({
  display: "flex",
  alignItems: "center",
  background: `${theme.palette.secondary.main}1A`,
  borderRadius: "0.25rem",
  paddingX: "0.75rem",
  height: (event.location?.name ?? event.zipcode?.label) ? "3rem" : "2rem",
  [theme.breakpoints.up("lg")]: {
    height: "2rem",
  },

  "& .event-date-time-location": {
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "1%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "-webkit-box",
    wordBreak: "break-all",
    WebkitLineClamp: "1",
    WebkitBoxOrient: "vertical",
  },

  "& .event-date-time-location-icon": {
    fontSize: "0.875rem",
    color: theme.palette.secondary.main,
    marginRight: "0.5rem",
  },
});
